import Button from "../button";
import { Flex } from "antd";
import Text from "../text";
import React from "react";

const Dialog = ({ icon, description = "", buttons = [] }) => {
  return (
    <div>
      <Flex gap={"2rem"} align="center">
        {icon && <img src={icon} style={{ width: "5rem" }} />}
        <Text color="secondary" children={description} />
      </Flex>
      {!!buttons.length && (
        <Flex
          gap={"1rem"}
          className="m-30-t"
          children={React.Children.toArray(
            buttons.map((button) => {
              return <Button {...button} />;
            })
          )}
        />
      )}
    </div>
  );
};

export default Dialog;
